<template>
  <div
    id="kt_modal_csosn_consultar"
    ref="kt_modal_csosn_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Situação da Operação - Simples Nacional</h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('exibirModalCSOSN', false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <h4 class="text-primary ms-4">Origem</h4>
          <div class="card border border-rounded border-gray-300 mb-4 p-6">
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN0"
                    value="0"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN0">
                    0 - Nacional, exceto as indicadas nos códigos 3, 4, 5 e 8.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN1"
                    value="1"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN1">
                    1 - Estrangeira - Importação direta, exceto a indicada no
                    código 6.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN2"
                    value="2"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN2">
                    2 - Estrangeira - Adquirida no mercado interno, exceto a
                    indicada no código 7.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN3"
                    value="3"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN3">
                    3 - Nacional, mercadoria ou bem com Conteúdo de Importação
                    superior a 40% e inferior ou igual a 70%.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN4"
                    value="4"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN4">
                    4 - Nacional, cuja produção tenha sido feita em conformidade
                    com os processos produtivos básicos de que tratam as
                    legislações citadas nos Ajustes.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN5"
                    value="5"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN5">
                    5 - Nacional, mercadoria ou bem com Conteúdo de Importação
                    inferior ou igual a 40%.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN6"
                    value="6"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN6">
                    6 - Estrangeira - Importação direta, sem similar nacional,
                    constante em lista da CAMEX e gás natural.
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNOrigem"
                    id="rbCSOSN7"
                    value="7"
                    v-model="this.chkCSOSNOrigem"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rbCSOSN7">
                    7 - Estrangeira - Adquirida no mercado interno, sem similar
                    nacional, constante em lista da CAMEX e gás natural.
                  </label>
                </div>
              </div>
            </div>
          </div>
          <h4 class="text-primary ms-4">Tributação</h4>
          <div class="card border border-rounded border-gray-300 mb-0 p-6">
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb101"
                    value="101"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb101">
                    101 - Tributado pelo Simples Nacional com Permissão de
                    Crédito
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb102"
                    value="102"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb102">
                    102 - Tributado pelo Simples Nacional sem Permissão de
                    Crédito
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb103"
                    value="103"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb103">
                    103 - Isenção do ICMs no Simples Nacional para faixa de
                    receita Bruta
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb201"
                    value="201"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb201">
                    201 - Tributada pelo Simples Nacional com permissão de
                    crédito e com cobrança de ICMs por substituição tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb202"
                    value="202"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb202">
                    202 - Tributada pelo Simples Nacional sem permissão de
                    crédito e com cobrança de ICMs por substituição tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb203"
                    value="203"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb203">
                    203 - Isenção do ICMs no Simples Nacional para faixa de
                    receita bruta e com cobrança do ICMs por substituição
                    tributária
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb300"
                    value="300"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb300">
                    300 - Imune
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb400"
                    value="400"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb400">
                    400 - Não tributada pelo Simples Nacional
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb500"
                    value="500"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb500">
                    500 - ICMs cobrado anteriormente por substituição
                    tributária(substituído) ou por antecipação
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-auto fv-row d-flex justify-content-start mb-4">
                <div class="form-check form-check-custom form-check-sm">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="rbCSOSNTributacao"
                    id="rb900"
                    value="900"
                    v-model="this.chkCSOSNTributacao"
                  />
                  <label class="form-check-label fs-6 fw-bold" for="rb900">
                    900 - Outros
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-success svg-icon-white mb-2"
            data-bs-dismiss="modal"
            @click="confirmarCSOSN()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ["exibirModalCSOSN", "confirmarCSOSN"],
  props: {
    csosn: { type: String, required: true },
  },
  methods: {
    confirmarCSOSN() {
      this.$emit(
        "confirmarCSOSN",
        this.chkCSOSNOrigem + this.chkCSOSNTributacao
      );
    },
  },
  async mounted() {
    var ccsosn = this.csosn;
    if (this.csosn === null || this.csosn.length != 4) {
      ccsosn = "0102";
    }
    this.chkCSOSNOrigem = ccsosn.substring(0, 1);
    this.chkCSOSNTributacao = ccsosn.substring(1, 4);
  },
  data() {
    return {
      chkCSOSNOrigem: "0",
      chkCSOSNTributacao: "102",
    };
  },
};
</script>

<style></style>
